
import { useContext } from '@nuxtjs/composition-api';
import useRouteChange from '@/composable/useRouteChange';
import useSelectorSteps from '~/composable/useSelectorSteps';

export default {
  props: {
    trackingData: {
      type: Object,
      default: () => {}
    },
    categorySlug: {
      type: String,
      default: 'modems'
    },
    errorSheetLinkButtons: {
      type: Array,
      default: () => []
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { app } = useContext()
    const {
      model
    } = useSelectorSteps(app)
    const { routeToCheckout } = useRouteChange()
    return {
      model,
      routeToCheckout
    }
  },
  data() {
    return {
      errorSheetDetails: {
        image: require('@/assets/images/bg_pink_2600x588.png'),
        title: 'Hov! Vi har da vist sovet lidt i timen.',
        description: 'Det ser ud til at det abonnement du valgte ikke findes mere.\n' +
          '\n' +
          'Det bliver helt sikkert rettet snart, men vi har da heldigvis andre attraktive abonnementer, der med sikkerhed virker ;)'
      }
    }
  }
}
